import React from 'react';
import { Col, Row } from 'react-bootstrap';
import html from "../images/htmlpng.png"
import css from "../images/css.png"
import Bootstrap from "../images/bootstarp.png"
import tailwind from "../images/Tailwind.png"
import mui from "../images/mui.png"
import js from "../images/js2.png"
import ts from "../images/Typescript.png"
import ReactJS from "../images/react.png"
import NodeJS from "../images/node.png"
import MongoDB from "../images/mongodb.svg"
import express from "../images/expressjs-icon.svg"
import redux from "../images/redux.png"
import git from "../images/gitpng.png"
import github from "../images/github.png"
import figma from "../images/figma.svg"
import firebase from "../images/firebase.png"
import sass from "../images/sass.png"
import heroku from "../images/heroku.png"
import axios from "../images/axios.png"
import netlify from "../images/netlify.png"
// import aws from "../images/aws.png"
import jquery from "../images/jquery.png"
import mysql from "../images/MySQL.png"
import trello from "../images/trello.png"
import jira from "../images/jira.svg"



const About = () => {
    return (
        <div id="about">
            <div className=" p-4 rounded" style={{ marginTop: '10px' }}>
                <h2 className="mb-5 title-color">  My Skills</h2>

                <h4 className='mb-3'>Technologies</h4>

                <Row xs={1} md={6} className="align-items-center" >
                    <Col style={{ marginBottom: '50px' }} className="rounded">
                        <div className=" box border border-secondary p-3 text-center">
                            <img style={{ width: '90px' }} className=' mb-3' src={html} alt="" />
                            <h5>HTML5</h5>
                        </div>
                    </Col>
                    <Col style={{ marginBottom: '50px' }} className="rounded">
                        <div className=" box border border-secondary p-3 text-center">
                            <img style={{ width: '90px' }} className='mb-3' src={css} alt="" />
                            <h5>CSS3</h5>
                        </div>
                    </Col>
                    <Col style={{ marginBottom: '50px' }} className="rounded">
                        <div className=" box border border-secondary p-3 text-center">
                            <img style={{ width: '110px' }} className='mb-3' src={Bootstrap} alt="" />
                            <h5>Bootstrap4</h5>
                        </div>
                    </Col>
                    <Col style={{ marginBottom: '50px' }} className="rounded">
                        <div className=" box border border-secondary p-3 text-center">
                            <img style={{ width: '90px' }} className='mb-3' src={tailwind} alt="" />
                            <h5>Tailwind CSS</h5>
                        </div>
                    </Col>

                    <Col style={{ marginBottom: '50px' }} className="rounded">
                        <div className=" box border border-secondary p-3 text-center">
                            <img style={{ width: '110px' }} className='mb-3' src={mui} alt="" />
                            <h5>Metarial UI</h5>
                        </div>
                    </Col>

                    <Col style={{ marginBottom: '50px' }} className="rounded">
                        <div className=" box border border-secondary p-3 text-center">
                            <img style={{ width: '110px' }} className=' mb-3' src={sass} alt="" />
                            <h5>SASS</h5>
                        </div>
                    </Col>
                    <Col style={{ marginBottom: '50px' }} className="rounded">
                        <div className=" box border border-secondary p-3 text-center">
                            <img style={{ width: '90px' }} className='mb-3' src={js} alt="" />
                            <h5>Javascript</h5>
                        </div>
                    </Col>
                    <Col style={{ marginBottom: '50px' }} className="rounded">
                        <div className=" box border border-secondary p-3 text-center">
                            <img style={{ width: '90px' }} className='mb-3' src={ts} alt="" />
                            <h5>TypeScript</h5>
                        </div>
                    </Col>
                    <Col style={{ marginBottom: '50px' }} className="rounded">
                        <div className=" box border border-secondary p-3 text-center">
                            <img style={{ width: '125px' }} className=' mb-3' src={ReactJS} alt="" />
                            <h5>ReactJS</h5>
                        </div>
                    </Col>
                    <Col style={{ marginBottom: '50px' }} className="rounded">
                        <div className=" box border border-secondary p-3 text-center">
                            <img className='w-50 mb-3' src={NodeJS} alt="" />
                            <h5>NodeJS</h5>
                        </div>
                    </Col>

                    <Col style={{ marginBottom: '50px' }} className="rounded">
                        <div className=" box border border-secondary p-3 text-center">
                            <img style={{ width: '90px' }} className='mb-3' src={MongoDB} alt="" />
                            <h5>MongoDB</h5>
                        </div>
                    </Col>
                    <Col style={{ marginBottom: '50px' }} className="rounded">
                        <div className=" box border border-secondary p-3 text-center py-4">
                            <img style={{ width: '120px' }} className='mb-3' src={express} alt="" />
                            <h5>ExpressJS</h5>
                        </div>
                    </Col>
                    <Col style={{ marginBottom: '50px' }} className="rounded">
                        <div className=" box border border-secondary p-3 text-center">
                            <img style={{ width: '90px' }} className=' mb-3' src={redux} alt="" />
                            <h5>Redux</h5>
                        </div>
                    </Col>
                    <Col style={{ marginBottom: '50px' }} className="rounded">
                        <div className=" box border border-secondary p-3 text-center">
                            <img style={{ width: '85px' }} className=' mb-3' src={axios} alt="" />
                            <h5>Axios</h5>
                        </div>
                    </Col>

                    <Col style={{ marginBottom: '50px' }} className="rounded">
                        <div className=" box border border-secondary p-3 text-center">
                            <img style={{ width: '125px' }} className=' mb-3' src={mysql} alt="" />
                            <h5>MySQL</h5>
                        </div>
                    </Col>
                    <Col style={{ marginBottom: '50px' }} className="rounded">
                        <div className=" box border border-secondary p-3 text-center">
                            <img className='w-50 mb-3' src={jquery} alt="" />
                            <h5>JQuery</h5>
                        </div>
                    </Col>

                </Row>

                <h4 className='mb-3'>Tools</h4>
                <Row xs={1} md={6} className="align-items-center" >

                    <Col style={{ marginBottom: '50px' }} className="rounded">
                        <div className=" box border border-secondary p-3 text-center">
                            <img style={{ width: '105px' }} className=' mb-3' src={firebase} alt="" />
                            <h5>Firebase</h5>
                        </div>
                    </Col>

                    <Col style={{ marginBottom: '50px' }} className="rounded">
                        <div className=" box border border-secondary p-3 text-center">
                            <img className='w-50 mb-3' src={git} alt="" />
                            <h5>Git</h5>
                        </div>
                    </Col>
                    <Col style={{ marginBottom: '50px' }} className="rounded">
                        <div className=" box border border-secondary p-3 text-center">
                            <img className='w-50 mb-3' src={github} alt="" />
                            <h5>Github</h5>
                        </div>
                    </Col>
                    <Col style={{ marginBottom: '50px' }} className="rounded">
                        <div className=" box border border-secondary p-3 text-center">
                            <img className='w-50 mb-3' src={heroku} alt="" />
                            <h5>Heroku</h5>
                        </div>
                    </Col>
                    <Col style={{ marginBottom: '50px' }} className="rounded">
                        <div className=" box border border-secondary p-3 text-center">
                            <img className='w-50 mb-3' src={netlify} alt="" />
                            <h5>Netlify</h5>
                        </div>
                    </Col>

                    <Col style={{ marginBottom: '50px' }} className="rounded">
                        <div className=" box border border-secondary p-3 text-center">
                            <img style={{ width: '50px' }} className=' mb-3' src={figma} alt="" />
                            <h5>FIgma</h5>
                        </div>
                    </Col>
                    <Col style={{ marginBottom: '50px' }} className="rounded">
                        <div className=" box border border-secondary p-3 text-center">
                            <img style={{ width: '70px' }} className=' mb-3' src={jira} alt="" />
                            <h5>Jira</h5>
                        </div>
                    </Col>
                    <Col style={{ marginBottom: '50px' }} className="rounded">
                        <div className=" box border border-secondary p-3 text-center">
                            <img style={{ width: '75px' }} className=' mb-3' src={trello} alt="" />
                            <h5>Trello</h5>
                        </div>
                    </Col>

                </Row>
            </div>
        </div >
    );
};

export default About;